import { service } from "@/ajax/request";
import { AxiosPromise } from "axios";

export const watchConfigList = (params): AxiosPromise =>{
    return service({
        url: `/watch-config/list`,
        method: "POST",
        params,
      });
}

export const getBindRecords = (params): AxiosPromise =>{
    return service({
        url: `/watch-config/binding-records`,
        method: "POST",
        params
      });
}

export const unBind = (params): AxiosPromise =>{
  return service({
      url: `/watch-config/release-binding-records`,
      method: "POST",
      params
    });
}



